export default function(key: string, fallback?: string): string {
  const prefixedKey = `VUE_APP_` + key;
  const env = String(process.env[prefixedKey]);
  if (env == ``) {
    return fallback === undefined ? "" : fallback;
  }
  return env;
}
